import { Text } from '@shopify/polaris';
import { memo } from 'react';
import type { TextProps } from '@shopify/polaris';

type IAlignment = 'start' | 'center' | 'end' | 'justify';

interface IBoldTextProps {
  children: React.ReactNode;
  alignment?: IAlignment;
  className?: string;
  tone?: TextProps['tone'];
  props?: TextProps;
}

const BoldText = ({ children, alignment, tone, props }: IBoldTextProps) => {
  return (
    <Text as="h6" variant="headingMd" alignment={alignment} tone={tone} {...props}>
      {children}
    </Text>
  );
};
export default memo(BoldText);
